import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { ThemeProvider } from "@mui/material/styles";
import goldenGate from "src/media/golden_gate.jpg";
import theme from "src/styles/mainstyle";
import { useMediaQuery, useTheme } from "@mui/material";
import FindHomesSearchBox from "src/components/search/FindHomesSearchBox";

export default function Intro() {
  const mobileTheme = useTheme();
  const isDesktop = useMediaQuery(mobileTheme.breakpoints.down("sm"));
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          backgroundImage: `url(${goldenGate})`,
          backgroundPosition: "60% 10%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: !isDesktop ? "80vh" : "70vh", // Use minHeight instead of height
          paddingTop: "100px", // Add padding at the top
          px: { xs: 2, sm: 0 },
          boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.3)", // Add a shadow below the box
        }}
      >
        <Typography
          variant="h1"
          component="h1"
          align="center"
          sx={{
            marginTop: !isDesktop ? 8 : 0,
            marginLeft: { xs: 0, sm: "10%" }, // Shift the text to the left
            textAlign: "left",
            width: { xs: "100%", sm: "75%" }, // Ensure row break at half the page width
            // color: backgroundColor,
          }}
        >
          A free platform to swap homes
        </Typography>
        {!isDesktop && (
          <Typography
            variant="h2"
            component="h2"
            align="center"
            sx={{
              marginTop: 3,
              // fontSize: isDesktop ? "4rem" : "2.5rem", // Enlarge the text
              marginLeft: { xs: 0, sm: "10%" }, // Shift the text to the left
              textAlign: "left",
              color: "white",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Make an exchange today
          </Typography>
        )}
        <Box
          sx={{
            marginTop: { xs: 5, sm: 3 },
            marginLeft: { xs: 0, sm: "10%" },
            width: "100%",
            maxWidth: { xs: "100%", sm: 560 },
            pb: { xs: 3, sm: 4 },
          }}
        >
          <FindHomesSearchBox mode="inline" source="landing_search_box" />
        </Box>
      </Box>
    </ThemeProvider>
  );
}
